<template src="@/templates/dhs/invoiceModel.html"></template>

<script>
	import moment from 'moment'

	export default {
		name: "invoiceModel",
		props: ['modelData'],
		data() {
			return {
				currentDate: moment().format('DD-MM-YYYY'),
				showingCurrentDate: false,
				invoiceModel: {},
				viewInvoice: false
			}
		},
		created() {
			this.invoiceModel = this.modelData;
		},
		methods: {
			showJobSlip(jobID) {

				Event.$emit('viewInvoiceDetails', jobID)

			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/dhs/invoiceModel.vue